import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: scrollEvent.
 * @param {object} ScrollEventParams Object with the scroll event details.
 * @param {string} ScrollEventParams.scrollDepth Depth of scroll
 * @param {string} ScrollEventParams.scrollDirection direction of scrolling (up or down)
 * @param {string} ScrollEventParams.scrollComponent The component scrolled past
 * @param {string} ScrollEventParams.scrollComponentPlacement Placement of component
 * @param {string} ScrollEventParams.scrollRootPage The root folder/page of website
 * @param {string} ScrollEventParams.scrollCategory The most recent section that is scrolled past
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { scrollEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * scrollEvent({
 *    scrollDepth: "23",
 *    scrollDirection: "D",
 *    scrollComponent: "primary-triplet",
 *    scrollComponentPlacement: "Position 2",
 *    scrollRootPage: "http://www.chase.com",
 *    scrollCategory: "your money/understand your finance"
 * });
 *
 * // With additional payload data
 * scrollEvent(
 *   {
 *    scrollDepth: "23",
 *    scrollDirection: "D",
 *    scrollComponent: "primary-triplet",
 *    scrollComponentPlacement: "Position 2",
 *    scrollRootPage: "http://www.chase.com",
 *    scrollCategory: "your money/understand your finance"
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function scrollEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.SCROLL, params, customPayload);
}
